import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=892c8f52&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=892c8f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c8f52",
  null
  
)

export default component.exports